import React, { useState } from "react";
import { useParams } from "react-router";
import { CalWarning } from "../../calcheck/CalWarning";
import {
    Celebration,
    getMorningAndEveningCelebrations,
} from "../../calendar/ordinariate-calendar";
import { CalendarDay } from "../../calendar/utils";
import { LiturgyViewer } from "../../liturgy/LiturgyViewer";
import { useDataDependency } from "../../utils/RemoteDataProvider";
import { TweakProvider } from "../../utils/TweakProvider";
import { useSettings } from "../../utils/settings";
import { OrdinariateLessons } from "./ordinariate-liturgy";
import { getOfficeOfTheDead } from "./ordinariate-office-of-the-dead";

export const OrdinariateOfficeOfTheDead: React.FC<{}> = () => {
    const { hour: rawHour } = useParams<{
        hour: "mattins" | "evensong";
    }>();

    const hour = rawHour === "evensong" ? "second-evensong" : rawHour;
    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    const year = getMorningAndEveningCelebrations(
        new Date().getFullYear(),
        false,
        false,
        false,
        regionLabels
    );

    const today = year.find(
        (day) =>
            day.date === new Date().getDate() &&
            day.month === new Date().getMonth() + 1 &&
            day.year === new Date().getFullYear()
    );

    if (!today) {
        throw new Error("Could not find today");
    }

    const { settings, setSetting } = useSettings();

    const benAntIds: string[] = [
        "ood make thy way",
        "ood turn thee o lord",
        "ood lest he devour",
        "ood from the gate",
        "ood i am the",
        "ood i will walk",
        "ood woe is me",
        "ood the lord shall",
        "ood if thou lord",
        "ood despise not",
        "ood all that the",
    ];
    const magAntIds: string[] = [];
    const invAntIds: string[] = ["ood inv"];

    const day: CalendarDay = {
        date: 1,
        month: 1,
        year: 1,
        dayOfTheWeek: "sun",
        label: "office-of-the-dead",
        otherLabels: [],
        collectId: "office-of-the-dead",
        collect: "office-of-the-dead",
        weekOfTheYear: 1,
        antiphonId: "office-of-the-dead",
        dayOfTheYear: 1,
        sentenceId: "office-of-the-dead",
        hymnId: "office-of-the-dead",
        easterOctave: false,
    };

    const celebration: Celebration = {
        label: "office-of-the-dead",
        type: "misc",
        rank: 10,
        title: "Office of the Dead",
    };

    const loadableLessons = useDataDependency<OrdinariateLessons>({
        type: "ord readings",
        day,
        hour,
        celebration,
        hymnIds: [],
        benAntIds,
        magAntIds,
        invAntIds,
        oneDayAheadPsalter: settings.oneDayAheadPsalter === "true",
    });

    const [antiphonOption, setAntiphonOption] = useState("Full");

    const [selectedPsalms, setSelectedPsalms] = useState("");

    const [simplifiedHaecDies, onSetSimplifiedHaecDies] = useState("Full");

    const [includeIntroduction, onSetIncludeIntroduction] = useState("Omit");

    const liturgy = getOfficeOfTheDead(
        day,
        hour,
        celebration,
        settings,
        loadableLessons,
        "",
        () => undefined,
        settings.salutation === "o lord hear our prayer"
            ? "Lay officiant"
            : "Priest officiant",
        (newType: string) => {
            if (newType === "Lay officiant") {
                setSetting("salutation", "o lord hear our prayer");
            }
            if (newType === "Priest officiant") {
                setSetting("salutation", "the lord be with you");
            }
        },
        antiphonOption,
        setAntiphonOption,
        "",
        () => undefined,
        selectedPsalms,
        setSelectedPsalms,
        false,
        false,
        simplifiedHaecDies,
        onSetSimplifiedHaecDies,
        includeIntroduction,
        onSetIncludeIntroduction
    );

    return (
        <TweakProvider initialState={{}}>
            <div
                style={{
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64,
                }}
            >
                <div
                    style={{
                        fontSize: "150%",
                        fontWeight: "bold",
                        lineHeight: 1.2,
                    }}
                >
                    {hour === "mattins" ? "Mattins" : "Evensong"} of the Dead
                </div>
            </div>
            <LiturgyViewer
                items={liturgy}
                label={"office-of-the-dead"}
                superTitle={hour === "mattins" ? "Mattins of" : "Evensong of"}
                title={"Office of the Dead"}
            />
            <CalWarning />
        </TweakProvider>
    );
};
